import { render } from "./index.vue?vue&type=template&id=31dcf022&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=31dcf022&scoped=true&lang=scss"
import "./index.vue?vue&type=style&index=1&id=31dcf022&lang=css"

import exportComponent from "/data/jenkins/workspace/yh-node-yh-mallrobot-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31dcf022"]])

export default __exports__